import { useEffect, useState } from 'react';
import { BASE_URL } from '../constants/urls';
import axios from 'axios';

const useStorePriority = () => {

    const [priorityStores, setPriorityStores] = useState([]);
    const [loadingPriorityStores, setLoadingPriorityStores] = useState(true);
    const [errorPriorityStores, setErrorPriorityStores] = useState(null);

    useEffect(() => {

        const fetchstoresPriority = async () => {
            try {
                const res = await axios.get(`${BASE_URL}/store/priority`, {
                    headers: { Authorization: `Bearer ${process.env.REACT_APP_API_TOKEN}`}
                });
                setPriorityStores(res.data)
            } catch (err) {
                const msg = err?.response?.data?.message || err.message || 'Erro desconhecido';
                setErrorPriorityStores(msg);
            } finally {
                setLoadingPriorityStores(false);
            }
        };

        fetchstoresPriority();
    }, []);

    return { priorityStores, loadingPriorityStores, errorPriorityStores };
}

export default useStorePriority